module.exports = __webpack_public_path__ + "img/rad-conv-Sala-Standard-2.3c3724fc.png";